<template>
  <sub-page :title="title">
    <div class="form-page">
      <div class="form-body">
        <div class="form-item">
          <span class="form-label required">证件号</span>
          <input class="form-input" type="text" placeholder="请输入证件号" v-model="idCard" maxlength="18" />
        </div>
        <div class="form-item">
          <span class="form-label required">证书号</span>
          <input class="form-input" type="text" placeholder="请输入证书号" v-model="certNo" />
        </div>
        <div class="form-item">
          <span class="form-label required">图形验证码</span>
          <input class="form-input" type="text" placeholder="请输入图形验证码" v-model="captcha" maxlength="4" />
          <div class="captcha-wrap">
            <img :src="captchaImg" class="captcha-img" @click="refreshCaptcha" />
          </div>
        </div>
      </div>
      <div class="form-footer">
        <button class="submit-btn" @click="handleSubmit">查询</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'SkillCert',
  components: { SubPage },
  data() {
    return {
      title: '专项职业能力证书查询',
      idCard: '',
      certNo: '',
      captcha: '',
      captchaImg: ''
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let str = ''
      for (let i = 0; i < 4; i++) str += chars[Math.floor(Math.random() * chars.length)]
      const canvas = document.createElement('canvas')
      canvas.width = 120
      canvas.height = 40
      const ctx = canvas.getContext('2d')

      // 背景
      ctx.fillStyle = '#f0f0f0'
      ctx.fillRect(0, 0, 120, 40)

      // 干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.getRandomColor()
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(Math.random() * 120, Math.random() * 40)
        ctx.lineTo(Math.random() * 120, Math.random() * 40)
        ctx.stroke()
      }

      // 干扰点
      for (let i = 0; i < 20; i++) {
        ctx.fillStyle = this.getRandomColor()
        ctx.beginPath()
        ctx.arc(Math.random() * 120, Math.random() * 40, 1, 0, Math.PI * 2)
        ctx.fill()
      }

      // 文字（斜体）
      ctx.fillStyle = '#000'
      ctx.font = 'italic bold 26px Arial'
      ctx.textBaseline = 'middle'
      for (let i = 0; i < 4; i++) {
        const x = 15 + i * 25 + Math.random() * 5
        const y = 20 + Math.random() * 6 - 3
        const angle = (Math.random() - 0.5) * 0.3
        ctx.save()
        ctx.translate(x, y)
        ctx.rotate(angle)
        ctx.fillText(str[i], 0, 0)
        ctx.restore()
      }

      this.captchaImg = canvas.toDataURL()
    },
    getRandomColor() {
      const r = Math.floor(Math.random() * 150)
      const g = Math.floor(Math.random() * 150)
      const b = Math.floor(Math.random() * 150)
      return `rgb(${r},${g},${b})`
    },
    handleSubmit() {
      // 提交逻辑
    }
  }
}
</script>

<style scoped>
.form-page {
  background: #F3F8FB;
  min-height: 100%;
}
.form-body {
  background: #fff;
  margin-top: calc(24 * var(--w));
}
.form-item {
  display: flex;
  align-items: center;
  height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(36 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(200 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  font-size: calc(36 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #969799;
}
.captcha-wrap {
  flex-shrink: 0;
  margin-left: calc(16 * var(--w));
}
.captcha-img {
  width: calc(120 * var(--w));
  height: calc(50 * var(--w));
  border-radius: calc(4 * var(--w));
  cursor: pointer;
}
.form-footer {
  padding: calc(60 * var(--w)) calc(32 * var(--w));
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(40 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/SkillCert.vue